export enum RoutePaths {
  LOGIN = '/login',
  OTP_LOGIN = '/login/otp',
  PASSWORD_LOGIN = '/login/password',
  AUTOLOGIN = '/autologin',
  HOME = '/',
  PROFILE = '/profile',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/restore-password',
  LOGOUT = '/logout',
  ABOUT = '/about',
  PERSANAL_DATA = 'personal-data',
  ACCOUNT_MANAGEMENT = '/profile/account-management',
  MY_SUBSCRIPTION = 'my-subscription',
  MY_GUIDES = 'my-guides',
  //TODO: Remove after POC
  PLAYER_V2 = '/player-v2',
}

export const publicRoutes: string[] = [
  RoutePaths.LOGIN,
  RoutePaths.OTP_LOGIN,
  RoutePaths.PASSWORD_LOGIN,
  RoutePaths.AUTOLOGIN,
  RoutePaths.FORGOT_PASSWORD,
  RoutePaths.LOGOUT,
  RoutePaths.RESET_PASSWORD,
  //TODO: Remove after POC
  RoutePaths.PLAYER_V2,
  `/${RoutePaths.MY_GUIDES}`,
  `${RoutePaths.ACCOUNT_MANAGEMENT}/${RoutePaths.MY_SUBSCRIPTION}`,
];
